import { memo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CustomSelect } from '../Selects/CustomSelect'

interface IFilterDropdownProps {
  label: string
  options: string[]
  defaultOption: string
  filterBy: string
}

const Filter: React.FC<IFilterDropdownProps> = memo(
  ({
    label, options, defaultOption, filterBy,
  }) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const handleClick = (_name: string, option: string) => {
      if (!option) {
        searchParams.delete(filterBy)
        searchParams.delete('p')
        setSearchParams(searchParams)
        return
      }
      if (option === defaultOption) {
        searchParams.delete(filterBy)
        searchParams.delete('p')
        setSearchParams(searchParams)
      } else {
        searchParams.set(filterBy, option)
        searchParams.delete('p')
        setSearchParams(searchParams)
      }
    }

    return (
      <>
        <CustomSelect
          onSelectChange={handleClick}
          options={[defaultOption, ...options]}
          selectedOption={searchParams.get(filterBy) || defaultOption}
          name=""
        />
        <div className="tc-mv-admin-filter-label">{label}</div>
      </>
    )
  },
)

export { Filter }
